import { useEffect, useState } from 'react'
import { useReducedMotion } from 'motion/react'

// Hydration-safe version of motion's useReducedMotion: the server and the first client render both say false,
// and the visitor's real preference is applied right after mount.
export const usePrefersReducedMotion = (): boolean => {
    const prefers = useReducedMotion()
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    return mounted && Boolean(prefers)
}
